import { Controller } from "stimulus"

// Expands / collapses the details section of an AI job list item.
// On click:
//   - If clicking inside the already-expanded details area (buttons,
//     links, forms), let the event through without toggling
//   - Otherwise, toggle this item's details open/closed
// Only one item is expanded at a time — clicking a new item collapses
// any currently open one.
export default class extends Controller {
  static targets = ["details"]
  static values = { loggedIn: String }

  toggle(e) {
    // If the click is on a link, button, or form inside the details
    // area or on the inline save button, don't interfere — let the
    // browser/Turbo handle it normally.
    if (e.target.closest('[data-ai-job-toggle-target="details"]') ||
        e.target.closest('.ai-job-inline-save')) {
      return
    }

    // If user is not logged in, open the login modal instead of expanding
    if (this.loggedInValue !== "true") {
      e.preventDefault()
      const modal = document.getElementById('loginModal')
      if (modal && typeof jQuery !== 'undefined') {
        jQuery(modal).modal('show')
      }
      return
    }

    // Prevent the click from doing anything else (e.g. following a
    // link on the compact row itself)
    e.preventDefault()

    const currentlyOpen = !this.detailsTarget.classList.contains('d-none')

    // Collapse every other open AI job item on the page
    document.querySelectorAll('[data-controller~="ai-job-toggle"] [data-ai-job-toggle-target="details"]').forEach(el => {
      el.classList.add('d-none')
    })

    // Toggle this one — if it was already open, keep it closed (since
    // the line above just closed it); otherwise, open it.
    if (!currentlyOpen) {
      this.detailsTarget.classList.remove('d-none')
    }
  }
}
